module.exports = __webpack_public_path__ + "static/img/twelve.63174ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/expert/twelve.png
// module id = KmJI
// module chunks = 0